import { callEndpoint } from 'redux/global';
import { IResponse } from 'types';
import {
  fetchDbDataWithCache,
  getDbCacheContextFromState,
} from 'utils/dbIndexedCache';

export const verifyAuth = () => async (dispatch: Function): Promise<IResponse> => {
  const res: IResponse = await dispatch(
    callEndpoint({
      api: 'verify',
      method: 'GET',
    }),
  );
  return res;
};

/** gethotel returns [row]; some cache writes stored the row object itself. */
export const hotelFromGetHotelData = (data: unknown) => {
  if (Array.isArray(data) && data[0]) return data[0];
  if (data && typeof data === 'object' && (data as { id?: unknown }).id != null) {
    return data;
  }
  return null;
};

export const getHotel = (id: string, forceRefresh = false) => async (
  dispatch: Function,
  getState: Function,
): Promise<IResponse> => {
  const ctx = {
    ...getDbCacheContextFromState(getState()),
    hotelId: id,
  };
  return fetchDbDataWithCache(ctx, {
    table: 'hotel',
    forceRefresh,
    fetchFromBe: () => dispatch(
      callEndpoint({
        api: 'gethotel',
        method: 'POST',
        body: { id }
      }),
    ),
  });
};

export const getCustomers = (forceRefresh = false) => async (
  dispatch: Function,
  getState: Function,
): Promise<IResponse> => {
  const ctx = getDbCacheContextFromState(getState());
  return fetchDbDataWithCache(ctx, {
    table: 'customers',
    forceRefresh,
    fetchFromBe: () => dispatch(
      callEndpoint({
        api: 'get-customers',
        method: 'GET',
      }),
    ),
  });
};
